<template>
	<div class="swiper-wrapper image-slider-wrapper">
		<swiper
			class="swiper"
			:options="swiperOption"
			 ref="imageSlider"
		>

			<swiper-slide
				v-for="(item, key) in items"
				:key="key"
			>
				<div class="image-slider">

					<div class="image-slider--image-wrapper">
						<img
							v-if="getSliderImage(key)"
							:src="getSliderImageSrc(key)"
							:alt="getSliderProperties(key).alternative"
						/>
					</div>

				</div>
			</swiper-slide>
		</swiper>
		<div class="swiper-pagination-round" slot="pagination"></div>
		<div class="swiper-button-prev" slot="button-prev"></div>
		<div class="swiper-button-next" slot="button-next"></div>
	</div>
</template>

<script>
	import ButtonSecondary from '~/components/atoms/forms/buttons/ButtonSecondary';
	import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
	export default {
		name: 'ContentSlider',
		components: {
			Swiper,
			SwiperSlide,
			ButtonSecondary
		},
		props: {
			items: {
				type: Array,
				required: true,
				default: () => []
			}
		},
		data() {
			return {
				swiperOption: {
					slidesPerView: 1,
					spaceBetween: 50,
					autoHeight: true,
					pagination: {
						clickable: true,
						el: '.swiper-pagination-round',
					},
					navigation: {
						disabledClass: 'swiper-button-disabled',
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					},
					observer: true,
       				observeParents: true,
				},
			}
		},
		methods: {
			getSliderImage (index) {
				return this.items[index]?.content.image
					|| [/* empty array */]
				;
			},
			getSliderImageSrc (index) {
				const image = this.getSliderImage(index);
				return image[0]?.publicUrl
					|| null
				;
			},
			getSliderProperties (index) {
				const image = this.getSliderImage(index);
				return image[0]?.properties
					|| {/* empty object */}
				;
			}
		},
		computed: {
			swiper() {
				return this.$refs.imageSlider.swiper
			}
   		},
	}
</script>

<style lang="scss">
	@import '~@/assets/scss/common';
	$image-slider--height: 500px !default;
	$image-slider--image-padding: 80px !default;
	$image-slider--image-padding-small: 20px !default;
	$image-slider--image-margin: 4% !default;
	$swiper-button-prev-icon-next-icon-color: color(primary, light) !default;
	$swiper-button-prev-icon-next-icon-color-hover: color(secondary, dark) !default;
	$swiper-button-prev-icon: arrow-circle-left !default;
	$swiper-button-next-icon: arrow-circle-right !default;
	$image-slider--bottom-wrapper--background: #fff !default;

	.image-slider-wrapper {
		height: 100%;
		margin-bottom: 2rem;

		@include media-breakpoint-up(md) {
			// height: $image-slider--height;
			margin-bottom: 0;
		}
	}
	.image-slider-container {
		position: relative;
	}

	.image-slider {
		position: relative;

		video,
		img {
			display: block;
			width: 100%;
			height: 100%;
			margin: 0 auto;
			object-fit: cover;
			font-family: 'object-fit: cover;';
		}
	}

	@include media-breakpoint-up(md) {

		.image-slider--image-wrapper {

			figure,
			picture {
				display: block;
				height: 100%;
			}
		}

	}


	.image-slider--image {
		flex: 0 1 auto;
		position: relative;
		padding-top: 30px;
		padding-bottom: 10px;
	}


</style>
